import { STORAGE_KEYS } from '../storage.keys';
import { storageService } from '../storage.service';

const keys = {
    tenantS3Asset: "tenantS3Asset", // string
    mealsCollapseMenuOptions: "mealsCollapseMenuOptions", // boolean
    mealsHideSeniorInformationInKitchensApp: "mealsHideSeniorInformationInKitchensApp", // boolean
    permissions: "permissions", // string[] (e.g. MealsDriver, MobileCreateMealOrders)
    navigationMapApp: "navigationMapApp" // "google" | "apple" | "waze" (default "google"; platform filtering done at point of use)
};

export const settingsStorage = {
    getTenantS3Asset: () => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        return data?.[keys.tenantS3Asset] || "";
    },
    setTenantS3Asset: (asset) => storageService.update(STORAGE_KEYS.APP_SETTINGS, { [keys.tenantS3Asset]: asset }),
    getMealsCollapseMenuOptions: () => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        return data?.[keys.mealsCollapseMenuOptions] || false;
    },
    setMealsCollapseMenuOptions: (option) => storageService.update(STORAGE_KEYS.APP_SETTINGS, { [keys.mealsCollapseMenuOptions]: option }),
    getMealsHideSeniorInformationInKitchensApp: () => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        return data?.[keys.mealsHideSeniorInformationInKitchensApp] || false;
    },
    setMealsHideSeniorInformationInKitchensApp: (option) => storageService.update(STORAGE_KEYS.APP_SETTINGS, { [keys.mealsHideSeniorInformationInKitchensApp]: option }),
    getNavigationMapApp: () => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        const value = data?.[keys.navigationMapApp];
        return value === "apple" || value === "waze" ? value : "google";
    },
    setNavigationMapApp: (app) => storageService.update(STORAGE_KEYS.APP_SETTINGS, { [keys.navigationMapApp]: (app === "apple" || app === "waze") ? app : "google" }),
    getPermissions: () => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        return Array.isArray(data?.[keys.permissions]) ? data[keys.permissions] : [];
    },
    setPermissions: (permissions) => storageService.update(STORAGE_KEYS.APP_SETTINGS, { [keys.permissions]: Array.isArray(permissions) ? permissions : [] }),
    hasPermission: (permission) => {
        let data = storageService.get(STORAGE_KEYS.APP_SETTINGS, false);
        let list = Array.isArray(data?.[keys.permissions]) ? data[keys.permissions] : [];
        return list.includes(permission);
    },
};

